export const light = {
  name: 'Light',
  color: [0, 0.6, 1, 1],
  bg: [1, 1, 1, 1],
  grid1: [0, 0, 0, 0.2],
  grid2: [0, 0, 1, 0.1],
}
